









































  import { defineComponent, ref, PropType } from 'vue'
  import useCurrentInstance from '~/utils/useCurrentInstance'
  import OneProductStocksLabel from '~/components/organisms/product/OneProductStocksLabel.vue'

  export default defineComponent({
    name: 'OneProductStocksPopupDialog',
    components: {
      OneProductStocksLabel,
    },
    props: {
      warehouses: {
        type: Array as PropType<any[]>,
        required: true,
      },
      unit: {
        type: String,
        required: true,
      },
      moreStocksTxt: {
        type: String,
        required: true,
      },
      product: {
        type: Object as PropType<any>,
        required: true,
      },
      productBlocked: {
        type: Boolean,
        required: true,
      },
    },
    setup(props) {
      const vm = useCurrentInstance()

      const showStocksPopup = ref(false)

      const onClose = () => {
        showStocksPopup.value = false
      }

      const closable = {
        exclude: ['button'],
        handler: 'onClose',
      }

      const getIconClass = (type: string): string => {
        return type === 'LOCAL' ? 'icon-geolocalize' : 'icon-main-warehouse'
      }

      const shippingTime = (time: string): string => {
        return time ? `${time} ${vm.$t('product_page.hour')}` : ''
      }

      const checkStockQty = (stock: any): string => {
        if (props.productBlocked && stock.quantity === 0) {
          return ''
        } else if (!props.productBlocked && stock.quantity === 0) {
          return props.product.shippingTime
        } else {
          return shippingTime(stock.shippingTime)
        }
      }

      return {
        showStocksPopup,
        closable,
        onClose,
        getIconClass,
        checkStockQty,
      }
    },
  })
